<template>
  <v-menu v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-menu>
</template>

<script>
export default {
  name: "AMenu",
};
</script>

<style scoped>
::v-deep .v-list-item__title {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  /* font-size: 14px !important; */
}
::v-deep.v-menu__content{
  /* z-index: 10010 !important; */
}
</style>